import { Instagram, MapPin, MessageCircle, Phone } from "lucide-react";
import { company } from "@/lib/siteData";
import { directWhatsAppUrl } from "@/hooks/useWhatsAppMessage";
import { Link } from "react-router-dom";

export const Footer = () => (
  <footer className="site-footer" data-testid="site-footer">
    <div className="footer-grid">
      <div data-testid="footer-company-block">
        <strong data-testid="footer-company-name">{company.tradeName}</strong>
        <p data-testid="footer-legal-name">{company.legalName}</p>
        <p data-testid="footer-registration">CNPJ {company.cnpj} · C.M.C. {company.municipalRegistration} · S.F.A. {company.sfa}</p>
      </div>
      <div data-testid="footer-contact-block">
        <a href={`tel:${company.phoneRaw}`} data-testid="footer-phone-link"><Phone size={16} /> {company.phoneDisplay}</a>
        <a href={directWhatsAppUrl()} data-testid="footer-whatsapp-link"><MessageCircle size={16} /> WhatsApp 24h</a>
        <a href={company.instagram} target="_blank" rel="noreferrer" data-testid="footer-instagram-link"><Instagram size={16} /> Instagram</a>
      </div>
      <div data-testid="footer-address-block">
        <a href={company.maps} target="_blank" rel="noreferrer" data-testid="footer-maps-link"><MapPin size={16} /> {company.address}</a>
        <p data-testid="footer-cep">CEP {company.cep}</p>
      </div>
    </div>
    <div className="footer-bottom" data-testid="footer-bottom-bar">
      <p>© {new Date().getFullYear()} {company.tradeName}. Todos os direitos reservados.</p>
      <div className="footer-links">
        <Link to="/politica-de-privacidade" data-testid="footer-privacy-link">Política de Privacidade</Link>
        <span>·</span>
        <Link to="/termos-de-uso" data-testid="footer-terms-link">Termos de Uso</Link>
        <span>·</span>
        <a href="/robots.txt" target="_blank" rel="noreferrer" data-testid="footer-robots-link">Robots.txt</a>
        <span>·</span>
        <a href="/sitemap.xml" target="_blank" rel="noreferrer" data-testid="footer-sitemap-link">Sitemap</a>
      </div>
    </div>
  </footer>
);